import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import childrenReducer from "./slices/childrenSlice";
import eventsReducer from "./slices/eventsSlice";
import realtimeReducer from "./slices/realtimeSlice";
import notificationsReducer from "./slices/notificationsSlice";
import onboardingReducer from "./slices/onboardingSlice";
import profileReducer from "./slices/profileSlice";
import sharingReducer from "./slices/sharingSlice";
import { realtimeMiddleware } from "./middleware/realtimeMiddleware";
import {
  performanceMiddleware,
  debounceMiddleware,
  selectiveUpdateMiddleware,
} from "./middleware/performanceMiddleware";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    children: childrenReducer,
    events: eventsReducer,
    realtime: realtimeReducer,
    notifications: notificationsReducer,
    onboarding: onboardingReducer,
    profile: profileReducer,
    sharing: sharingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
      // Enable immutability and serializability checks only in development
      immutableCheck: import.meta.env.DEV,
    }).concat(
      realtimeMiddleware,
      performanceMiddleware,
      debounceMiddleware,
      selectiveUpdateMiddleware
    ),
  devTools: import.meta.env.NODE_ENV !== "production",
});

// Type exports removed - use TypeScript files for type definitions if needed
